// Generated by ts-to-zod
import { z } from 'zod';

export const reportTypeDtoSchema = z.literal('rms-monthly');

export const periodKindDtoSchema = z.literal('MONTHLY');

export const rmsReportDtoSchema = z.object({
  id: z.string(),
  reportType: reportTypeDtoSchema,
  customer: z.object({
    id: z.string(),
    name: z.string(),
  }),
  site: z.object({
    id: z.string(),
    name: z.string(),
  }),
  equipment: z.array(
    z.object({
      equipmentId: z.string(),
      name: z.string(),
    })
  ),
  period: z.object({
    kind: periodKindDtoSchema,
    from: z.string(),
    to: z.string(),
    label: z.string().optional(),
  }),
  timezone: z.string(),
  title: z.string(),
  templateId: z.string().optional(),
  createdAt: z.string(),
  createdBy: z.string(),
  updatedAt: z.string(),
});
